import { PERFORMANCE_TYPES_ID, TP } from './consts';

export const musicalWork = {
  composerField: {
    name: 'composer',
    title: `${TP}.FN_SELECT_COMPOSER_NAME`,
    label: `${TP}.m_COMPOSER`,
    placeholder: `${TP}.FN_ENTER_COMPOSER_NAME`,
  },
  workField: {
    name: 'name',
    title: `${TP}.FN_ENTER_MUSICAL_WORK`,
    label: `${TP}.m_MUSICALWORK`,
    placeholder: `${TP}.FN_WORK_TITLE_EXAMPLE`,
  },
  aliasField: {
    name: 'alias',
    label: `${TP}.FN_ALIAS_NAME_OPTIONAL`,
    placeholder: `${TP}.FN_ALIAS_NAME`,
  },
  librettists: {
    name: 'workLibrettists',
    title: `${TP}.FN_ENTER_LIBRETTIST_INFO`,
    label: `${TP}.FN_LIBRETTIST_NAME`,
    placeholder: `${TP}.m_ENTERNAME`,
  },
  librettoLanguage: {
    name: 'librettoLanguage',
    label: `${TP}.FN_LIBRETTO_LANGUAGE`,
    placeholder: `${TP}.m_ENTERNAME`,
  },
  librettoDescription: {
    name: 'librettoDescription',
    label: `${TP}.FN_COMMENTS_ABOUT_LIBRETTO_SOURCE`,
  },
  workType: {
    name: 'workType',
    title: `${TP}.FN_ENTER_MUSIC_WORK_DETAILS`,
    label: `${TP}.FN_MUSICAL_WORK_TYPE`,
    placeholder: `${TP}.m_SELECT2`,
  },
  musicStyle: {
    name: 'musicStyle',
    label: `${TP}.FN_STYLE_OF_MUSIC`,
    placeholder: `${TP}.m_SELECT2`,
  },
  workAs: {
    name: 'workAs',
    label: `${TP}.FN_MARK_WORK_AS`,
    placeholder: `${TP}.m_SELECT2`,
  },
  summary: {
    name: 'summary',
    label: `${TP}.FN_ADD_WORK_SUMMARY`,
  },
  premiereDate: {
    name: 'premiereDate',
    title: `${TP}.FN_ADD_WHEN_WORK_PREMIERED`,
    label: `${TP}.FN_PREMIERE_DATE`,
    placeholder: `${TP}.FN_DATE_PLACEHOLDER`,
  },
  premiereTime: {
    name: 'premiereTime',
    label: `${TP}.FN_PREMIERE_TIME`,
  },
  company: {
    name: 'company',
    label: `${TP}.REGISTRATION_FORM_COMPANY`,
    placeholder: `${TP}.SEARCH_COMPANY`,
  },
  areRolesUnknown: {
    name: 'areRolesUnknown',
    label: `${TP}.UNKNOWN_ROLES_LABEL`,
  },
  roleNameField: {
    name: 'roleName',
    title: `${TP}.FN_ENTER_ROLES_AND_VOICE`,
    subtitle: `${TP}.FN_ADD_ROLES_TO_DATABASE`,
    label: `${TP}.m_ROLE`,
    placeholder: `${TP}.FN_ENTER_ROLE`,
  },
  voiceType: {
    name: 'professionQualification',
    label: `${TP}.FN_CHOOSE_VOICE_TYPE`,
    placeholder: `${TP}.m_SELECT2`,
  },
};

export const IS_CO_PRODUCED = 'is_co_produced';

export const musicalWorkFields = {
  composerField: {
    name: 'composer_id',
    label: `${TP}.m_COMPOSER`,
    placeholder: `${TP}.SORT_WORKCOMPOSER_NAME`,
    value: undefined,
    productionName: 'work.composer',
  },
  workField: {
    name: 'work_id',
    label: `${TP}.SEARCH_PRODUCTION`,
    placeholder: `${TP}.SEARCH_PRODUCTION`,
    value: undefined,
    productionName: 'work',
  },
  name: {
    name: 'production',
    label: `${TP}.FN_PRODUCTION_TITLE`,
    value: '',
    productionName: 'name',
  },
  doubleBillField: {
    name: PERFORMANCE_TYPES_ID.DOUBLE_BILL,
    label: `${TP}.FN_DOUBLE_BILL`,
    tooltip: `${TP}.FN_DOUBLE_BILL_TOOLTIP`,
    value: false,
  },
  doubleWorks: {
    name: 'doubleWorks',
    value: [],
    productionName: 'works',
  },
  productionTypesField: {
    name: 'types',
    label: `${TP}.FN_PRODUCTION_TYPE`,
    value: {
      [PERFORMANCE_TYPES_ID.WORLD_PREMIERE]: { value: false, label: `${TP}.FN_PERFORMACE_TYPE_WORLD_PREMIERE` },
      [PERFORMANCE_TYPES_ID.NATIONAL_PREMIERE]: { value: false, label: `${TP}.m_NATPREMIERE` },
      [PERFORMANCE_TYPES_ID.CONCERT]: { value: false, label: `${TP}.FN_PERFORMACE_TYPE_CONCERT` },
      [PERFORMANCE_TYPES_ID.NEW_PRODUCTION]: { value: false, label: `${TP}.m_NEWPROD` },
      [PERFORMANCE_TYPES_ID.RECITAL]: { value: false, label: `${TP}.FN_RECITAL` },
      [PERFORMANCE_TYPES_ID.LIVESTREAM]: { value: false, label: `${TP}.FN_LIVESTREAM` },
      [PERFORMANCE_TYPES_ID.VIDEO_ON_DEMAND]: { value: false, label: `${TP}.FN_VIDEO_ON_DEMAND` },
      [PERFORMANCE_TYPES_ID.FESTIVAL]: { value: false, label: `${TP}.FN_PART_OF_FESTIVAL_CHECKBOX` },
      [IS_CO_PRODUCED]: { value: false, label: `${TP}.FN_CO_PRODUCED_CHECKBOX` },
    },
    productionName: 'performanceTypes',
  },
  companyField: {
    name: 'company',
    label: `${TP}.SEARCH_COMPANY`,
  },
  isCompanyUnknownField: {
    name: 'isCompanyUnknown',
    label: `${TP}.FN_NOT_KNOWN_PRODUCTION_ORGANISER`,
  },
  coProducedCompaniesField: {
    name: 'company_id',
    label: `${TP}.SEARCH_COMPANY`,
    value: [{ value: undefined, label: '' }],
    productionName: 'companies',
  },
  festivalsField: {
    name: 'festival_id',
    label: `${TP}.FN_FESTIVAL_NAME`,
    value: [''],
    productionName: 'festivals',
  },
  producerfestivalsField: {
    name: 'producer_festival_id',
    label: `${TP}.FN_FESTIVAL_NAME`,
    value: [''],
    productionName: 'festivals',
  },
  languageField: {
    name: 'language',
    label: `${TP}.m_LANG`,
    value: [null],
    productionName: 'languages',
  },
  subtitlesField: {
    name: 'subtitle',
    label: `${TP}.FN_SURTITLE_LANGUAGE`,
    value: [null],
    productionName: 'subtitles',
  },
  productionPageField: {
    name: 'production_page',
    label: `${TP}.FN_PRODUCTION_WEBPAGE`,
    placeholder: `${TP}.FN_WEB_LINK_ENTER`,
    value: '',
    productionName: 'website',
  },
  boxOfficePageField: {
    name: 'box_office',
    label: `${TP}.FN_BOX_OFFICE_WEBPAGE`,
    placeholder: `${TP}.FN_WEB_LINK_ENTER`,
    value: '',
    productionName: 'boxOfficeWebsite',
  },
  bookingDateField: {
    name: 'booking_date',
    value: '',
    productionName: 'bookingStartDate',
    label: `${TP}.m_DATE`,
  },
  bookingTimeField: {
    name: 'booking_time',
    value: '',
    productionName: 'bookingStartTime',
    label: `${TP}.FN_ADD_TIME`,
  },
};

export const registerFields = {
  firstName: {
    id: 'firstName',
    label: `${TP}.m_EDIT_ROSTER_LIST_FIRSTNAME`,
    placeholder: `${TP}.ENTER_FIRSTNAME_PLACEHOLDER`,
    type: 'text',
  },
  lastName: {
    id: 'lastName',
    label: `${TP}.m_EDIT_ROSTER_LIST_LASTNAME`,
    placeholder: `${TP}.ENTER_LASTNAME_PLACEHOLDER`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.m_EMAIL`,
    placeholder: `${TP}.ENTER_EMAIL_PLACEHOLDER`,
    type: 'email',
  },
  confirmEmail: {
    id: 'confirmEmail',
    label: `${TP}.m_REGISTRATION_CONFIRMEMAIL`,
    type: 'email',
  },
  confirmPassword: {
    id: 'confirmPassword',
    label: `${TP}.REGISTRATION_CONFIRMPASS`,
    placeholder: `${TP}.REGISTRATION_CONFIRMPASS_PLACEHOLDER`,
    type: 'password',
  },
  password: {
    id: 'password',
    label: `${TP}.REGISTRATION_ENTERPASS`,
    placeholder: `${TP}.ENTER_PASSWORD_PLACEHOLDER`,
    type: 'password',
  },
  type: {
    id: 'type',
    label: `${TP}.m_REGISTRATION_REGISTERAS`,
    type: 'password',
  },
};

export const profileTypeFields = {
  firstName: {
    id: 'firstName',
    label: `${TP}.m_EDIT_ROSTER_LIST_FIRSTNAME`,
    placeholder: `${TP}.ENTER_FIRSTNAME_PLACEHOLDER`,
    type: 'text',
  },
  lastName: {
    id: 'lastName',
    label: `${TP}.m_EDIT_ROSTER_LIST_LASTNAME`,
    placeholder: `${TP}.ENTER_FIRSTNAME_PLACEHOLDER`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.m_EMAIL`,
    type: 'email',
    placeholder: `${TP}.ENTER_EMAIL_PLACEHOLDER`,
  },
  profession: {
    id: 'profession',
    label: `${TP}.m_EDIT_ROSTER_LIST_PROFESSION`,
  },
  voiceType: {
    id: 'voiceType',
    label: `${TP}.m_REGISTRATION_VOICE_TYPE`,
  },
  country: {
    id: 'country',
    label: `${TP}.FIELDS_AOS_COUNTRY`,
    type: 'text',
  },
};

export const agencyCreateFields = {
  fullName: {
    id: 'fullName',
    label: `${TP}.FIELDS_AGENCY_FULL_NAME`,
    type: 'text',
  },
  shortName: {
    id: 'shortName',
    label: `${TP}.FIELDS_AGENCY_SHORT_NAME`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.FIELDS_AGENCY_EMAIL`,
    type: 'email',
  },
  website: {
    id: 'website',
    label: `${TP}.FIELDS_AGENCY_WEBSITE`,
    type: 'text',
  },
  phone: {
    id: 'phone',
    label: `${TP}.FIELDS_AGENCY_PHONE`,
    type: 'text',
  },
  country: {
    id: 'country',
    label: `${TP}.FIELDS_AGENCY_COUNTRY`,
    type: 'text',
  },
};

export const aosCreateFields = {
  fullName: {
    id: 'fullName',
    label: `${TP}.FIELDS_AOS_FULL_NAME`,
    type: 'text',
  },
  country: {
    id: 'country',
    label: `${TP}.FIELDS_AOS_COUNTRY`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.FIELDS_AOS_EMAIL`,
    type: 'email',
  },
  website: {
    id: 'website',
    label: `${TP}.FIELDS_AOS_WEBSITE`,
    type: 'text',
  },
  phone: {
    id: 'phone',
    label: `${TP}.FIELDS_AOS_PHONE`,
    type: 'text',
  },
};

export const aosEmployeeCreateFields = {
  firstName: {
    id: 'firstName',
    label: `${TP}.m_FIRSTNAME`,
    type: 'text',
  },
  lastName: {
    id: 'lastName',
    label: `${TP}.m_LASTNAME`,
    type: 'text',
  },
  phone: {
    id: 'phone',
    label: `${TP}.m_DIRECTPHONENUMBER`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.m_DIRECTEMAIL`,
    type: 'email',
  },
};

export const employeeCreateFields = {
  fullName: {
    id: 'fullName',
    label: `${TP}.m_CONTACTPERSONFULLNAME`,
    type: 'text',
  },
  job: {
    id: 'job',
    label: `${TP}.m_JOBTITLE`,
    type: 'text',
  },
  phone: {
    id: 'phone',
    label: `${TP}.m_DIRECTPHONENUMBER`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.m_DIRECTEMAIL`,
    type: 'email',
  },
};

export const verificationFields = {
  firstName: {
    id: 'firstName',
    label: `${TP}.m_FIRSTNAME`,
    type: 'text',
  },
  lastName: {
    id: 'lastName',
    label: `${TP}.m_EDIT_ROSTER_LIST_LASTNAME`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.m_EMAIL`,
    type: 'email',
  },
  phone: {
    id: 'phone',
    label: `${TP}.m_DIRECTPHONENUMBER`,
    type: 'text',
  },
  language: {
    id: 'language',
    label: `${TP}.m_LANG`,
    type: 'text',
  },
};

export const createProProfileFields = {
  firstName: {
    id: 'firstName',
    label: `${TP}.m_FIRSTNAME`,
    type: 'text',
  },
  lastName: {
    id: 'lastName',
    label: `${TP}.m_LASTNAME`,
    type: 'text',
  },
  email: {
    id: 'email',
    label: `${TP}.m_EMAIL`,
    type: 'email',
  },
  confirmEmail: {
    id: 'confirmEmail',
    label: `${TP}.m_REGISTRATION_CONFIRMEMAIL`,
    type: 'email',
  },
  password: {
    id: 'password',
    label: `${TP}.m_PASSWORD`,
  },
  type: {
    id: 'type',
    label: `${TP}.m_REGISTRATION_REGISTERAS`,
    type: 'text',
  },
};
